(function () {
  'use strict';

  var modalSlick = null;
  var modalBound = false;

  function whenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function whenJqSlickReady(callback) {
    function run() {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        callback(window.jQuery);
        return true;
      }
      return false;
    }

    if (run()) return;

    window.addEventListener('load', function () {
      if (!run()) {
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (run() || tries > 40) clearInterval(timer);
        }, 100);
      }
    });
  }

  function pauseModalVideos($, $modal) {
    $modal.find('.image-list-item-video').each(function () {
      this.pause();
    });
  }

  function bindModalVideos($, $modal) {
    $modal.find('.image-list-item-video').each(function () {
      var video = this;
      if (video.dataset.dictacModalVideoBound) return;
      video.dataset.dictacModalVideoBound = 'true';

      video.addEventListener('pause', function () {
        $(video).siblings('.video-icon').show();
      });
      video.addEventListener('play', function () {
        $(video).siblings('.video-icon').hide();
      });
      video.addEventListener('ended', function () {
        $(video).siblings('.video-icon').show();
      });
    });
  }

  function ensureModalSlick($, $modal) {
    var $target = $modal.find('[data-dictac-instagram-slick]').first();
    if (!$target.length) return null;

    if ($target.hasClass('slick-initialized')) {
      modalSlick = $target;
      return $target;
    }

    if ($target.find('.img-box-outer').length <= 1) {
      return null;
    }

    modalSlick = $target.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      prevArrow:
        '<span class="prev-slide" aria-label="prev"><svg fill="none" width="16" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      nextArrow:
        '<span class="next-slide" aria-label="next"><svg fill="none" width="16" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      focusOnSelect: false,
      swipe: true,
    });

    return modalSlick;
  }

  function getModal($, gallery) {
    var $modal = $('[data-dictac-instagram-modal]').first();
    if (!$modal.length && gallery) {
      $modal = $(gallery).find('[data-dictac-instagram-modal]').first();
    }
    return $modal;
  }

  function openModal($, gallery, index) {
    var $modal = getModal($, gallery);
    if (!$modal.length) return;

    if (!$modal.parent().is('body')) {
      $('body').append($modal);
    }

    var $slick = ensureModalSlick($, $modal);
    if ($slick) {
      $slick.slick('slickGoTo', Number(index) - 1);
    }

    bindModalVideos($, $modal);
    setTimeout(function () {
      $modal.find('.video-icon').show();
    }, 800);

    $('body').addClass('cartover');
    $modal.css('display', 'block');
  }

  function closeModal($) {
    var $modal = $('[data-dictac-instagram-modal]');
    $modal.hide();
    $('body').removeClass('cartover');
    pauseModalVideos($, $modal);
  }

  function bindModal($, root) {
    if (modalBound) return;
    modalBound = true;

    var gallery = root.closest('[data-dictac-instagram-gallery]');

    $(document).on('click', '[data-dictac-instagram-card]', function (e) {
      var section = this.closest('[data-dictac-instagram]');
      if (!section || section.getAttribute('data-lightbox') === 'false') return;

      e.preventDefault();
      e.stopPropagation();

      var index = this.getAttribute('data-index');
      if (!index) return;

      openModal($, gallery, index);
    });

    $(document).on('click', '[data-dictac-instagram-modal-close], [data-dictac-instagram-modal] .slick-modal-mask-close', function () {
      closeModal($);
    });

    $(document).on('click', '[data-dictac-instagram-modal] .video-icon', function () {
      var $modal = $(this).closest('[data-dictac-instagram-modal]');
      pauseModalVideos($, $modal);
      var video = $(this).siblings('video')[0];
      if (video) {
        video.play();
        $(this).hide();
      }
    });

    $(document).on('click', '[data-dictac-instagram-modal] .next-slide, [data-dictac-instagram-modal] .prev-slide', function () {
      pauseModalVideos($, $('[data-dictac-instagram-modal]'));
    });

    if (gallery) {
      gallery.querySelectorAll('.instagram_product_handle').forEach(function (el) {
        if (el.dataset.dictacProductLoaded) return;
        el.dataset.dictacProductLoaded = 'true';
        if (typeof getProductInfo === 'function') {
          getProductInfo(el.getAttribute('data'), $(el), typeof getInstagramProductInfo === 'function' ? getInstagramProductInfo : undefined);
        }
      });
    }
  }

  function initInstagram(root) {
    if (!root || root.dataset.dictacInstagramInit) return;
    root.dataset.dictacInstagramInit = 'true';

    var rail = root.querySelector('[data-dictac-instagram-rail]');
    var progress = root.querySelector('[data-dictac-instagram-progress]');
    var prev = root.querySelector('[data-dictac-instagram-prev]');
    var next = root.querySelector('[data-dictac-instagram-next]');
    var cards = root.querySelectorAll('[data-dictac-instagram-card]');

    if (rail && window.DictacHome && window.DictacHome.initHorizontalRail) {
      window.DictacHome.initHorizontalRail(rail, {
        progressEl: progress,
        prevBtn: prev,
        nextBtn: next,
        preventClickOnDrag: true,
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var timer = null;

      function stopPreview() {
        if (timer) clearTimeout(timer);
        timer = null;
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        card.classList.remove('is-previewing');
      }

      function schedulePreview() {
        if (!video) return;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          video
            .play()
            .then(function () {
              card.classList.add('is-previewing');
            })
            .catch(function () {
              card.classList.remove('is-previewing');
            });
        }, 450);
      }

      card.addEventListener('pointerenter', schedulePreview);
      card.addEventListener('pointerleave', stopPreview);
      card.addEventListener('focus', schedulePreview);
      card.addEventListener('blur', stopPreview);
    });

    if (root.getAttribute('data-lightbox') !== 'false') {
      whenJqSlickReady(function ($) {
        bindModal($, root);
      });
    }
  }

  function bootInstagram() {
    document.querySelectorAll('[data-dictac-instagram]').forEach(initInstagram);
  }

  whenReady(bootInstagram);

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-dictac-instagram]') ||
      (event.target.matches('[data-dictac-instagram]') ? event.target : null);
    if (root) initInstagram(root);
  });
})();
